import { render } from "./add-qa.vue?vue&type=template&id=8073a4e8&scoped=true"
import script from "./add-qa.vue?vue&type=script&lang=js"
export * from "./add-qa.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./add-qa.vue?vue&type=style&index=1&id=8073a4e8&scoped=true&lang=css"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8073a4e8"]])

export default __exports__